import template from './userAccount.html';
import controller from './userAccount.controller';

let userAccountComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default userAccountComponent;



// WEBPACK FOOTER //
// ./app/components/userAccount/userAccount.component.js